import { Breadcrumb, Card, Col, Popconfirm, Row, Tabs } from 'antd'
import Amount from '../../../../components/Common/Amount'
import Documents from '../../../../components/Common/Documents/DocumentsCont'
import History from '../../../../components/Common/History'
import VendorQuotesLinesCont from '../../../../components/Purchasing/VendorQuotes/Lines/VendorQuotesLinesCont'
import PaymentTermsCont from '../../../../components/Purchasing/VendorQuotes/PaymentsTerms/PaymentTermsCont'
import VendorQuotesForm from '../../../../components/Purchasing/VendorQuotes/VendorQuotesForm'
import style from '../../../../components/Sales/style.css'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'
import RefreshButton from '../../../../elements/Buttons/RefreshButton'
import CodeIcon from '../../../../elements/CodeIcon'
import CustomSpin from '../../../../elements/CustomSpin'
import { MODAL_TYPE_EDIT } from '../../../../elements/Hooks/useModalData'
import LinkHeader from '../../../../elements/LinkHeader'
import Status from '../../../../elements/Status'
import _, { round, sum } from 'lodash'
import { numVal, strVal } from '../../../../modules/Utils'
import React, { Fragment } from 'react'

AddVendorQuote.propTypes = {}
const { TabPane } = Tabs

function AddVendorQuote (props) {
  const {
    type,
    submitting,
    updating,
    fetching,
    submit,
    fetch,
    update,
    formRef,
    vendorQuote,
    remove,
    removing,
    isUpdatable,
    actions,
    handleActions,
    fetchingLines,
    isConfirmed,
    isNew,
    submitQuote,
    lines,
  } = props

  const SubmitButton = () => (
    <FooterButtons
      style={{ marginBottom: 10 }}
      remove={remove}
      removing={removing}
      submit={submit}
      update={update}
      submitting={submitting || updating}
      title={'Department'}
      isNew={isNew}
      isEdit={!isNew}
    />
  )

  const Operations = ({ vendorQuote, ...rest }) => {
    const ops = actions
      .filter(a => a.key !== 'update' && a.key !== 'remove')
      .map(a => (
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to ${a.value}?`}
            onConfirm={() => handleActions(a.key)}
            okText="Yes"
            cancelText="No">
            <a>{a.value}</a>
          </Popconfirm>
        </span>
      ))

    {
      isConfirmed &&
      ops.push(
        <span>
            <Popconfirm
              placement="left"
              title={`Are you sure to Create Quote?`}
              onConfirm={submitQuote}
              okText="Yes"
              cancelText="No">
              <a>Create Quote</a>
            </Popconfirm>
          </span>,
      )
    }

    return (
      <div {...rest}>
        {ops.length > 0
          ? ops.reduce((prev, curr) => [prev, <span className="ant-divider"/>, curr])
          : []}
      </div>
    )
  }

  return (
    <CustomSpin spinning={fetching}>
      <LinkHeader
        title={'Vendor Quote'}
        link={{
          pathname: `/clients/enquiries/${_.get(vendorQuote, 'enquiry._id', '').replace(
            'activities/',
            '',
          )}/update`,
        }}
        code={_.get(vendorQuote, 'enquiry.code')}
        name={_.get(vendorQuote, 'enquiry.title')}
        visible={!_.isEmpty(_.get(vendorQuote, 'enquiry'))}
      />
      <Card>
        <Row className={style.pageHeader}>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Purchasing</Breadcrumb.Item>
            <Breadcrumb.Item href={`#/purchasing/vendor/quotes`}>Vendor Quotes</Breadcrumb.Item>
            <Breadcrumb.Item>
              {type === 'new' ? 'New Vendor Quote' : vendorQuote.code}
            </Breadcrumb.Item>
          </Breadcrumb>
          {type === 'new' && <h2 className={style.title}>New Vendor Quote</h2>}
          {type === 'edit' && (
            <Fragment>
              <Col span={17}>
                <h3 className={style.title}>
                  <CodeIcon code={strVal(vendorQuote, 'quoteNo')} title={'Vendor Quote No'}/>
                  <Status value={strVal(vendorQuote, 'status')}/>
                  <Operations
                    style={{ marginTop: '10px' }}
                    vendorQuote={vendorQuote}
                    status={strVal(vendorQuote, 'status')}
                  />
                </h3>
              </Col>
              <CustomSpin spinning={fetchingLines}>
                <Col span={5}>
                  <Amount
                    data={[
                      {
                        name: 'SUB-TOTAL (NET)',
                        amount: round(sum(lines.map(d => numVal(d, 'amount.net'))), 2),
                      },
                      {
                        name: 'TAX',
                        amount: round(sum(lines.map(d => numVal(d, 'amount.tax'))), 2),
                      },
                      {
                        name: 'TOTAL (GROSS)',
                        amount: round(sum(lines.map(d => numVal(d, 'amount.gross'))), 2),
                      },
                    ]}
                    currency={vendorQuote.currency}
                  />
                </Col>
              </CustomSpin>
              <RefreshButton onClick={fetch}/>
            </Fragment>
          )}
        </Row>
      </Card>
      <Card className={style.contentCard}>
        <Tabs defaultActiveKey="form">
          <TabPane tab="Details" key="form">
            <Row>
              <VendorQuotesForm ref={formRef} {...props} />
            </Row>
            <SubmitButton/>
          </TabPane>
          <TabPane disabled={isNew} tab={'Vendor Quote Lines'} key="#lines">
            <VendorQuotesLinesCont vendorQuote={vendorQuote} isUpdatable={isUpdatable}/>
          </TabPane>
          <TabPane disabled={isNew} tab={'Vendor Payment Terms'} key="#payment-terms">
            <PaymentTermsCont owner={vendorQuote} isUpdatable={isUpdatable}/>
          </TabPane>
          <TabPane disabled={isNew} tab="Documents" key="files">
            <Documents
              editable={true}
              footer={false}
              category={false}
              owner={vendorQuote}
              linkTo={true}
              linkToType={'Quotation'}
            />
          </TabPane>
          <TabPane disabled={type !== MODAL_TYPE_EDIT} tab="History" key="history">
            <History owner={vendorQuote} key={vendorQuote._rev} isArray={true}/>
          </TabPane>
        </Tabs>
      </Card>
    </CustomSpin>
  )
}

export default AddVendorQuote
